module.exports = __webpack_public_path__ + "img/DD_Headshot.4349bc25.png";